import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { createFocusTrap } from 'focus-trap';
import Cookies from 'js-cookie';

export default class SaveTheDateModal {

	constructor(element) {
		this.handleTriggerClick = this.handleTriggerClick.bind(this);
		this.handleCloseClick = this.handleCloseClick.bind(this);
		this.element = element;
		this.openClass = 'gigs-save-the-date-modal--open';
		this.successClass = 'gigs-save-the-date-modal--success';
		this.closeButton = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-save-the-date-modal__close') : undefined;
		this.overlay = (this.element instanceof HTMLElement) ? this.element.querySelector('.gigs-save-the-date-modal__overlay') : undefined;
		this.autoshow = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-autoshow') === 'true' : false;
		this.openTimeout = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-autoshow-timeout') : undefined;
		this.openTimer = undefined;
		this.seenCookie = (this.element instanceof HTMLElement) ? this.element.getAttribute('data-cookie-name') : undefined;
		this.seenCookieExpiration = (this.element instanceof HTMLElement) ? Number(this.element.getAttribute('data-cookie-expiration')) : undefined;
		this.blocklist = (this.element instanceof HTMLElement) ? JSON.parse( this.element.getAttribute('data-blocklist') || '[]' ) : [];
		this.triggerQuery = (this.element instanceof HTMLElement) ? `a[href="#${this.element.id}"]` : '';
		this.seenCookieOptions = {
			expires: this.seenCookieExpiration || undefined, // number in days, or undefined for session cookie.
		};
		this.focusTrap = null;
		this.wpAdminBar = document.getElementById('wpadminbar');
		this.focusableElements = [this.element];
		if (this.wpAdminBar) this.focusableElements.push(this.wpAdminBar);
	}

	init() {
		if (this.closeButton instanceof HTMLElement) {
			this.closeButton.addEventListener('click', this.handleCloseClick);
		}
		if (this.overlay instanceof HTMLElement) {
			this.overlay.addEventListener('click', this.handleCloseClick);
		}
		this.initTriggers();
		this.initFocusTrap();
		if (this.shouldAutoShow()) {
			this.setTimeout();
		}
	}

	destroy() {
		if (this.closeButton instanceof HTMLElement) {
			this.closeButton.removeEventListener('click', this.handleCloseClick);
		}
		if (this.overlay instanceof HTMLElement) {
			this.overlay.removeEventListener('click', this.handleCloseClick);
		}
		this.clearTimeout();
		this.destroyTriggers();
		this.destroyFocusTrap();
	}

	shouldAutoShow() {
		const hasSeenCookie = this.hasSeenCookie();
		const isPathBlocked = this.blocklist.some((path) => {
			const regex = new RegExp(path);
			return regex.test(window.location.pathname);
		});
		return ! hasSeenCookie && ! isPathBlocked;
	}

	initFocusTrap() {
		this.focusTrap = createFocusTrap(this.focusableElements, {
			onDeactivate: () => this.close(),
		});
	}

	destroyFocusTrap() {
		if (this.focusTrap) {
			this.focusTrap.deactivate();
			this.focusTrap = null;
		}
	}

	initTriggers(container) {
		container = (container instanceof HTMLElement) ? container : document;
		if (this.triggerQuery) {
			const triggers = container.querySelectorAll(this.triggerQuery);
			triggers.forEach(trigger => {
				trigger.addEventListener('click', this.handleTriggerClick);
			});
		}
	}

	destroyTriggers(container) {
		container = (container instanceof HTMLElement) ? container : document;
		if (this.triggerQuery) {
			const triggers = container.querySelectorAll(this.triggerQuery);
			triggers.forEach(trigger => {
				trigger.removeEventListener('click', this.handleTriggerClick);
			});
		}
	}

	handleTriggerClick(e) {
		e.preventDefault();
		this.open();
	}

	open() {
		if (this.element instanceof HTMLElement) {
			this.focusTrap.activate();
			this.element.classList.add(this.openClass);
			disableBodyScroll(this.element);
		}
	}

	close() {
		this.setSeenCookie();
		if (this.element instanceof HTMLElement) {
			this.element.classList.remove(this.openClass);
			this.focusTrap.deactivate();
			enableBodyScroll(this.element);
		}
	}

	setTimeout() {
		this.clearTimeout();
		if (this.autoshow) {
			this.openTimer = window.setTimeout(() => this.open(), Number(this.openTimeout || 0));
		}
	}

	clearTimeout() {
		if (this.openTimer) window.clearTimeout(this.openTimer);
	}

	hasSeenCookie() {
		return Boolean(Cookies.get(this.seenCookie));
	}

	setSeenCookie() {
		Cookies.set(this.seenCookie, '1', this.seenCookieOptions);
	}

	handleCloseClick(e) {
		e.preventDefault();
		this.close();
	}
}
